import { createGlobalStyle } from 'styled-components';

import reset from './reset.css';

const GlobalStyle = createGlobalStyle`
	@import url('https://fonts.googleapis.com/css?family=Lilita+One|Quicksand:400,700&display=swap');
	
	${reset}


	* {
		box-sizing: border-box;
	}
	
	.hide {
		position: absolute !important;
		clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
		clip: rect(1px, 1px, 1px, 1px);
		padding: 0 !important;
		border: 0 !important;
		height: 1px !important;
		width: 1px !important;
		overflow: hidden;
	}
	.bold {
		font-weight: 700;
	}

	html {
		font-size: 16px;
	}

	body {
		font-size: 16px;
		background-color: #fff;
		color: ${(p) => p.theme.color.dark};
		font-family: ${(props) => props.theme.fonts.body};
		overflow-x: hidden;
	
		input, textarea {
			border: none;
			border-radius: unset;
			font-size: 1rem;
			font-family: ${(props) => props.theme.fonts.body};
		}
		button {
			cursor: pointer;
			appearance: none;
			padding: 0;
			margin: 0;
    		text-decoration: none;
			border: none;
			color: #fff;
			background-color: transparent;
		}
		a {
			color: #fff;
			text-decoration: none;
		}
		hr {
			border: none;
			display: block;
			height: 1px;
			margin: 0.5rem 0;
		}
	}
	
`;

export default GlobalStyle;
